import { Button } from '@/components/ui/Button'
import { KpiBoard } from './KpiBoard'
import type { DashboardPayload } from '@/types/dashboard'

interface Props {
  data: DashboardPayload | null
  loading: boolean
  detecting: boolean
  draftCount: number
  onDetect: () => void
  onInbox: () => void
  onAutomations: () => void
  onRefresh: () => void
}

export function HeroCommand({
  data,
  loading,
  detecting,
  draftCount,
  onDetect,
  onInbox,
  onAutomations,
  onRefresh
}: Props) {
  return (
    <section className="block tab-block" id="overview">
      <div className="hero">
        <div className="hero-copy">
          <p className="eyebrow">Command center</p>
          <h1>
            Browser work, <span>governed</span>.
          </h1>
          <p className="lede">
            Detect repetitive SaaS flows, review verified proposals, confirm with policy and audit
            controls.
          </p>
          <div className="hero-cta">
            <Button variant="primary" onClick={onDetect} disabled={detecting}>
              {detecting ? 'Detecting…' : 'Detect patterns'}
            </Button>
            <Button onClick={onInbox}>
              Inbox{draftCount > 0 ? ` (${draftCount})` : ''}
            </Button>
            <Button size="sm" onClick={onAutomations}>
              Automations
            </Button>
            <Button size="sm" onClick={onRefresh}>
              Sync
            </Button>
          </div>
        </div>
        <KpiBoard data={data} loading={loading} />
      </div>

      <div className="quick-grid">
        <button type="button" className="quick-card" onClick={onInbox}>
          <strong>Proposal queue</strong>
          <span>Confirm or dismiss dry-run verified drafts</span>
        </button>
        <button type="button" className="quick-card" onClick={onAutomations}>
          <strong>Automations</strong>
          <span>Flows, templates, and live capture</span>
        </button>
        <button type="button" className="quick-card" onClick={onDetect} disabled={detecting}>
          <strong>Pattern detect</strong>
          <span>Scan domains for repeatable sequences</span>
        </button>
      </div>
    </section>
  )
}
